export const groupColours = {
  'Olympian': '#E8E288',
  'Titan': '#6B4B3E',
  'Mortal': '#FBD1A2',
  'Underworld': '#5C0029',
  'Nymph': '#BEA7E5',
  'Giants': '#9D8420',
  'Others': '#5AB1BB'
};
